import { CampaignType, ProductCampaignLiteViewModel } from '@models/api-search.models';
import { ActiveCampaign } from '@features/product/product.models';

export const getCampaignByType = (
    campaigns: ProductCampaignLiteViewModel[] | undefined,
    campaignType: CampaignType
): ActiveCampaign | undefined => campaigns?.find(campaign => campaign.campaignType === campaignType);
